import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const ROUNDPERC = () => {
  return (
    <CardSection id="ROUNDPERC" title="ROUNDPERC">
      <Paragraph>
        -100과 100 사이의 실제 백분율 값을 지정한 소수 자릿수로 반올림하여 0%와
        ±100%에 가까운 값이 최소한 지정한 소수 자릿수 이상을 갖도록 합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>ROUNDPERC(VALUE, PLACES)</Paragraph>
        <Ul>
          <Li>
            <b>VALUE</b>는 반올림하려는 실제 백분율 값입니다.
          </Li>
          <Li>
            <b>PLACES</b>는 반올림할 소수점의 최소 자릿수입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>VALUE</b>는 -100과 100 사이의 실제 백분율 값이거나, 실제
          백분율 값을 포함하는 열이거나, 실제 백분율 값을 반환하는 함수여야
          합니다.
        </Paragraph>
        <Paragraph>
          <b>PLACES</b> 값은 정수여야 합니다(소수점 불가). 지정한 것보다 소수점
          자릿수가 적은 <b>VALUE</b>는 <b>ROUNDPERC</b> 함수의 영향을 받지
          않습니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
